import { render } from "./TestimonialView.vue?vue&type=template&id=2f89f90d&scoped=true"
import script from "./TestimonialView.vue?vue&type=script&lang=js"
export * from "./TestimonialView.vue?vue&type=script&lang=js"

import "./TestimonialView.vue?vue&type=style&index=0&id=2f89f90d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f89f90d"]])

export default __exports__